// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".painel-corona[data-v-de5bf8d2]{margin-top:10px;background-color:#d9ead3}.ajust-image-corona[data-v-de5bf8d2]{width:100px;height:100px}", ""]);
// Exports
module.exports = exports;
